/* Aóuhra native cart. Shopify owns every price and discount. No fetch interception. */
(() => {
  'use strict';
  if (window.aouhraCart) return;
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const counts = cart => cart.items.reduce((m, i) => (m[i.variant_id] = (m[i.variant_id] || 0) + i.quantity, m), {});
  const equal = (a, b) => Object.keys({...a, ...b}).every(k => (a[k] || 0) === (b[k] || 0));
  const exactAdd = (before, after, items) => {
    const expected = counts(before);
    for (const i of items) expected[i.id] = (expected[i.id] || 0) + i.quantity;
    return equal(expected, counts(after));
  };
  let drawer, cart, busy = false, uncertain = false, opener, background = [], previousOverflow;
  const status = (text, removal = false, upsell = false) => { const node = drawer?.querySelector('[data-aouhra-status]'); if (node) { node.textContent = text; node.classList.toggle('aouhra-cart__status--removing', removal); node.classList.toggle('aouhra-cart__status--upselling', upsell); } const fallback = drawer?.querySelector('.aouhra-cart__fallback'); if (fallback) fallback.hidden = !text || text === 'Updating cart…'; };
  function lock(value) {
    busy = value;
    drawer?.setAttribute('aria-busy', String(value));
    drawer?.querySelectorAll('[data-aouhra-delta],[data-aouhra-remove],[data-aouhra-protection],[data-aouhra-upsell-add],[data-aouhra-variant]').forEach(x => x.disabled = value || uncertain || x.hasAttribute('data-unavailable'));
    drawer?.querySelector('[data-aouhra-checkout]')?.setAttribute('aria-disabled', String(value || uncertain));
  }
  async function request(path, body) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(root + path, {credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
        ...(body ? {method: 'POST', headers: body instanceof FormData ? {Accept: 'application/json'} : {'Content-Type': 'application/json', Accept: 'application/json'}, body: body instanceof FormData ? body : JSON.stringify(body)} : {})});
      let data;
      try { data = await response.json(); } catch (_) { throw new Error(response.status === 429 ? 'The store is limiting requests. Please wait and review your full cart.' : 'The cart connection could not be verified.'); }
      if (!response.ok) throw new Error(data.description || data.message || 'The cart could not be updated.');
      return data;
    } finally { clearTimeout(timer); }
  }
  const config = () => drawer.querySelector('[data-aouhra-config]').dataset;
  function parseState(container = drawer) { return JSON.parse(container.querySelector('[data-aouhra-state]').textContent); }
  function open(trigger) {
    if (!drawer) { location.href = root + 'cart'; return; }
    if (!drawer.classList.contains('active')) {
      opener = trigger instanceof HTMLElement ? trigger : document.activeElement;
      previousOverflow = document.body.style.overflow;
      background = [...document.body.children].filter(el => !el.contains(drawer) && !['SCRIPT','STYLE','LINK'].includes(el.tagName)).map(el => [el, el.inert]);
      background.forEach(([el]) => el.inert = true);
      document.body.classList.add('aouhra-cart-open'); document.body.style.overflow = 'hidden';
      drawer.classList.add('active', 'animate');
      drawer.querySelector('[data-aouhra-close]').focus();
      // Wait for Shrine's visibility transition before assigning initial focus.
      const settleFocus = () => { if (drawer.classList.contains('active') && !drawer.contains(document.activeElement)) drawer.querySelector('[data-aouhra-close]').focus(); };
      requestAnimationFrame(() => requestAnimationFrame(settleFocus));
      // Shrine transitions visibility for 300ms; one bounded fallback also covers
      // reduced-motion/no-transition paths without a recurring focus timer.
      setTimeout(settleFocus, 350);
      document.querySelector('.header__icon--cart')?.setAttribute('aria-expanded', 'true');
    }
  }
  function close() {
    drawer?.classList.remove('active');
    background.forEach(([el, was]) => el.inert = was); background = [];
    document.body.classList.remove('aouhra-cart-open');
    document.body.style.overflow = previousOverflow || '';
    document.querySelector('.header__icon--cart')?.setAttribute('aria-expanded', 'false');
    if (opener?.isConnected) opener.focus(); else document.querySelector('.header__icon--cart')?.focus();
  }
  async function render(authoritative) {
    const sections = await request('cart?sections=cart-drawer,cart-icon-bubble');
    if (!sections['cart-drawer']) throw new Error('Your cart is saved, but its preview did not load. Open your full cart.');
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const content = doc.querySelector('[data-aouhra-content]');
    if (!content) throw new Error('Cart preview unavailable. Open your full cart.');
    const rendered = parseState(content);
    if (authoritative && (!equal(counts(rendered), counts(authoritative)) || rendered.total_price !== authoritative.total_price || rendered.currency !== authoritative.currency)) throw new Error('Your cart changed. Open your full cart to review it.');
    const scroll = drawer.querySelector('.aouhra-cart__body')?.scrollTop || 0;
    const focusInside = drawer.contains(document.activeElement);
    drawer.querySelector('[data-aouhra-content]').replaceWith(content);
    drawer.querySelector('#aouhra-cart-title').textContent = doc.querySelector('#aouhra-cart-title').textContent;
    drawer.classList.toggle('is-empty', rendered.item_count === 0);
    if (sections['cart-icon-bubble']) {
      // Only same-origin Shopify section HTML is inserted; never cart property strings.
      const bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) bubble.innerHTML = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section')?.innerHTML || sections['cart-icon-bubble'];
    }
    cart = rendered;
    const body = drawer.querySelector('.aouhra-cart__body'); if (body) body.scrollTop = scroll;
    decorate();
    lock(busy);
    if ((focusInside || document.activeElement === document.body) && drawer.classList.contains('active')) drawer.querySelector('[data-aouhra-close]').focus();
    document.dispatchEvent(new CustomEvent('aouhra:cart-updated', {detail: {itemCount: cart.item_count, total: cart.total_price, currency: cart.currency}}));
  }
  // Only remove surplus/orphan protection. Never opt a buyer in automatically.
  async function normalizeProtection(current) {
    const pid = Number(config().protectionProduct);
    const protection = current.items.filter(i => i.product_id === pid);
    if (!protection.length) return current;
    const merchandise = current.items.some(i => i.product_id !== pid);
    const updates = {}; let keep = merchandise;
    for (const i of protection) { const quantity = keep ? 1 : 0; keep = false; if (i.quantity !== quantity) updates[i.key] = quantity; }
    if (Object.keys(updates).length) {
      try { return await request('cart/update.js', {updates}); }
      catch (error) { uncertain = true; throw error; }
    }
    return current;
  }
  async function refreshAndOpen(current, trigger) {
    if (busy || (window.astraBogoAdding && !current)) throw new Error('Another cart operation is in progress.');
    lock(true);
    try {
      cart = current || await request('cart.js');
      if (!uncertain) cart = await normalizeProtection(cart);
      await render(cart); status(uncertain ? 'A previous update is unconfirmed. Review your full cart before adding again.' : ''); open(trigger);
    } catch (error) { open(trigger); status(error.message + ' Use View full cart below.'); throw error; }
    finally { lock(false); }
  }
  async function mutate(action, expected, removeControl, upsellControl) {
    if (busy || uncertain || window.astraBogoAdding) return;
    lock(true); removeControl?.setAttribute('aria-busy', 'true'); upsellControl?.setAttribute('aria-busy', 'true'); upsellControl?.classList.add('aouhra-add-pending'); status('Updating cart…', Boolean(removeControl), Boolean(upsellControl)); let attempted = false, before;
    try {
      before = await request('cart.js');
      attempted = true;
      await action(before);
      let after = await request('cart.js');
      if (expected && !expected(before, after)) throw new Error('The cart changed during your request.');
      cart = await normalizeProtection(after);
      await render(cart); status('');
    } catch (error) {
      let reconciled = false;
      if (attempted) {
        try {
          cart = await request('cart.js');
          reconciled = Boolean(expected && expected(before, cart));
          if (reconciled) {
            const pid = Number(config().protectionProduct), protectionCount = cart.items.filter(i => i.product_id === pid).reduce((n, i) => n + i.quantity, 0);
            if (uncertain || protectionCount > 1 || (protectionCount && !cart.items.some(i => i.product_id !== pid))) { reconciled = false; throw new Error('Protection update unconfirmed.'); }
            try { await render(cart); } catch (presentationError) { status(presentationError.message + ' Your update is saved; use View full cart.'); return; }
          }
        } catch (_) { /* Never replay a possibly successful POST. */ }
      }
      if (!reconciled) {
        uncertain = attempted;
        status((attempted ? 'We could not confirm the update. It will not be repeated automatically. ' : '') + error.message + ' Review your full cart before trying again.');
      } else status('');
    } finally { await new Promise(resolve => setTimeout(resolve, 450)); removeControl?.removeAttribute('aria-busy'); upsellControl?.removeAttribute('aria-busy'); upsellControl?.classList.remove('aouhra-add-pending'); lock(false); }
  }
  async function add(items, formData, trigger) {
    if (busy || uncertain || window.astraBogoAdding) return;
    if (trigger?.matches('[data-aouhra-upsell-add]')) open(trigger);
    const live = document.createElement('span'); live.className = 'visually-hidden'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite');
    if (trigger && !drawer.contains(trigger)) { trigger.after(live); live.textContent = 'Updating cart…'; }
    await mutate(() => request('cart/add.js', formData || {items}), (before, after) => exactAdd(before, after, items), null, trigger instanceof HTMLButtonElement ? trigger : null);
    live.remove();
    trigger?.closest('quick-add-modal')?.hide(true);
    open(trigger);
  }
  // Absolute elapsed time survives section replacement/reopen/reload, including background tabs.
  const timerKey = 'aouhra-cart-session-deadline';
  let deadline = 0, timerInterval;
  try { deadline = Number(sessionStorage.getItem(timerKey)) || 0; } catch (_) {}
  function timerTick() {
    const node = drawer?.querySelector('[data-aouhra-timer]');
    if (!node) return;
    const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    node.hidden = remaining === 0;
    node.querySelector('[data-aouhra-clock]').textContent = `${Math.floor(remaining / 60).toString().padStart(2,'0')}:${(remaining % 60).toString().padStart(2,'0')}`;
  }
  function decorate() {
    clearInterval(timerInterval);
    const node = drawer.querySelector('[data-aouhra-timer]');
    if (!cart.item_count) { deadline = 0; try { sessionStorage.removeItem(timerKey); } catch (_) {} }
    if (node) {
      if (!deadline) { deadline = Date.now() + Math.max(1, Math.min(3600, Number(node.dataset.seconds) || 240)) * 1000; try { sessionStorage.setItem(timerKey, String(deadline)); } catch (_) {} }
      timerTick(); timerInterval = setInterval(timerTick, 1000);
    }
    const track = drawer.querySelector('.aouhra-cart__upsell-track');
    if (track) {
      const update = () => { const max = track.scrollWidth - track.clientWidth; drawer.querySelector('[data-aouhra-scroll="-1"]').disabled = track.scrollLeft <= 2; drawer.querySelector('[data-aouhra-scroll="1"]').disabled = track.scrollLeft >= max - 2; };
      track.addEventListener('scroll', update, {passive:true}); requestAnimationFrame(update);
    }
  }
  document.addEventListener('visibilitychange', timerTick);
  window.addEventListener('resize', () => { const track = drawer?.querySelector('.aouhra-cart__upsell-track'); track?.dispatchEvent(new Event('scroll')); });
  function bind() {
    const next = document.querySelector('cart-drawer[data-aouhra-cart]');
    if (!next || next === drawer) return;
    drawer = next; cart = parseState();
    // Reuse Shrine's cart element and product-form rendering contract, not its gift/timer handlers.
    drawer.open = trigger => { open(trigger); if (!busy) refreshAndOpen(null, trigger).catch(() => {}); };
    drawer.close = close;
    drawer.renderContents = () => refreshAndOpen().catch(() => {});
    drawer.setActiveElement = element => { opener = element; };
    drawer.getSectionsToRender = () => [{id: 'cart-drawer', selector: '#CartDrawer'}, {id: 'cart-icon-bubble'}];
    drawer.addEventListener('click', event => {
      const el = event.target.closest('button,a,[data-aouhra-protection],#CartDrawer-Overlay'); if (!el) return;
      if (el.matches('[data-aouhra-close],#CartDrawer-Overlay')) { event.preventDefault(); close(); return; }
      if (el.matches('[data-aouhra-checkout]') && (busy || uncertain)) { event.preventDefault(); return; }
      if (el.matches('[data-aouhra-delta],[data-aouhra-remove]')) {
        const line = el.closest('[data-key]'), key = line.dataset.key, oldQuantity = Number(line.dataset.quantity);
        const target = el.hasAttribute('data-aouhra-remove') ? 0 : oldQuantity + Number(el.dataset.aouhraDelta);
        let variant, expectedCount;
        mutate(before => {
          const current = before.items.find(i => i.key === key);
          if (!current || current.quantity !== oldQuantity) throw new Error('This cart line has changed.');
          variant = current.variant_id; expectedCount = counts(before)[variant] - oldQuantity + target;
          return request('cart/change.js', {id: key, quantity: target});
        }, (before, after) => {
          const expected = counts(before); expected[variant] = expectedCount;
          return equal(expected, counts(after));
        }, el.hasAttribute('data-aouhra-remove') ? el : null);
      }
      if (el.matches('[data-aouhra-scroll]')) { const track = drawer.querySelector('.aouhra-cart__upsell-track'); track?.scrollBy({left: Number(el.dataset.aouhraScroll) * (track.firstElementChild.getBoundingClientRect().width + 10), behavior: 'smooth'}); }
      if (el.matches('[data-aouhra-upsell-add]')) {
        const id = Number(el.closest('.aouhra-cart__upsell').querySelector('[data-aouhra-variant]').value);
        add([{id, quantity: 1}], null, el);
      }
    });
    drawer.addEventListener('change', event => {
      const el = event.target;
      if (el.matches('select[data-aouhra-variant]')) {
        const option = el.selectedOptions[0], tile = el.closest('.aouhra-cart__upsell');
        const addButton = tile.querySelector('[data-aouhra-upsell-add]');
        addButton.toggleAttribute('data-unavailable', option.disabled); addButton.disabled = busy || uncertain || option.disabled;
        const price = tile.querySelector('[data-upsell-price]');
        price.replaceChildren();
        if (option.dataset.compare) { const compare = document.createElement('s'); compare.textContent = option.dataset.compare; price.append(compare, ' '); }
        price.append(option.dataset.price);
        const image = tile.querySelector('img'); image.removeAttribute('srcset'); image.src = option.dataset.image;
      }
      if (el.matches('[data-aouhra-protection]')) {
        const enabled = el.checked, id = Number(config().protectionId), pid = Number(config().protectionProduct);
        mutate(before => {
          const lines = before.items.filter(i => i.product_id === pid);
          if (enabled && !lines.length) return request('cart/add.js', {items: [{id, quantity: 1}]});
          const updates = {}; lines.forEach((i, index) => updates[i.key] = enabled && index === 0 ? 1 : 0);
          return request('cart/update.js', {updates});
        }, (before, after) => after.items.filter(i => i.product_id === pid).reduce((n, i) => n + i.quantity, 0) === (enabled ? 1 : 0));
      }
    });
    decorate();
    lock(false);
  }
  document.addEventListener('focusin', event => {
    if (drawer?.classList.contains('active') && !drawer.contains(event.target)) drawer.querySelector('[data-aouhra-close]').focus();
  });
  document.addEventListener('keydown', event => {
    if (!drawer?.classList.contains('active')) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); close(); }
    if (event.key === 'Tab') {
      const nodes = [...drawer.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = nodes[0], last = nodes.at(-1);
      if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    }
  }, true);
  // Native selected-variant forms keep their Liquid inputs and browser validation.
  // Capture replaces (never duplicates) Shrine's submit handler in this draft drawer mode.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!drawer || !form.matches('product-form form') || !new URL(form.action).pathname.endsWith('/cart/add')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy || uncertain || window.astraBogoAdding) return;
    const data = new FormData(form), id = Number(data.get('id')), quantity = Number(data.get('quantity') || 1);
    if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity < 1) { open(); status('Choose an available variant before adding.'); return; }
    const trigger = event.submitter || document.activeElement;
    add([{id, quantity}], data, trigger);
  }, true);
  window.addEventListener('pageshow', event => { if (event.persisted && !busy) { close(); refreshAndOpen().then(close).catch(() => {}); } });
  // Collection quick-add injects HTML without executing its deferred scripts.
  // Load the shared selector only when a shopper opens an options modal.
  let astraLoading;
  const astraSource = document.querySelector('script[data-astra-source]')?.dataset.astraSource;
  document.addEventListener('click', event => {
    if (!event.target.closest('modal-opener') || customElements.get('astra-bogo') || astraLoading || !astraSource) return;
    astraLoading = document.createElement('script'); astraLoading.src = astraSource;
    astraLoading.onerror = () => { astraLoading.remove(); astraLoading = null; };
    document.head.append(astraLoading);
  }, true);
  document.addEventListener('shopify:section:load', bind);
  window.aouhraCart = {refreshAndOpen, open, close, getCart: () => cart, markUncertain() { uncertain = true; lock(busy); }, get busy() { return busy || uncertain; }};
  customElements.whenDefined('cart-drawer').then(bind);
})();
